import styled from "styled-components";

const HeaderStyled = styled.h1`
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: italic;
  color: white;
  background-color: red;

  .iconContainer {
    margin: 0.5rem;
  }
`;

export default HeaderStyled;
